<unity-page-container [contentHeader]="$contentHeader()" [contentHeaderSecondary]="$contentHeaderSecondary()" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container notifications />

  @let formSchemaName = $formSchemaName();
  <ng-container actions>
    <unity-workflow-selector-shared
      [transitions]="$transitionsThatDoNotRequireValidation()"
      [disabled]="$isEditing()"
      (workflowEvent)="onWorkflow($event)" />
    <unity-action-delete-shared
      *unityAuthorize="deleteEntitlement"
      [disabled]="$isEditing()"
      [buttonText]="`Delete ${formSchemaName}`"
      [confirmationTitle]="`Confirm Delete ${formSchemaName}?`"
      [confirmationMessage]="`Are you sure you want to delete this ${formSchemaName}?`"
      (deleteEvent)="onDelete()" />
  </ng-container>

  @let formSchema = $formSchema();
  @let transitionsThatRequireValidation = $transitionsThatRequireValidation();
  @let surveyModel = $surveyModel();

  @if (formSchema && surveyModel) {
    <unity-card-manage-survey-shared
      [resource]="$resource()"
      [isEditable]="$isEntitledToEdit()"
      [isEditing]="$isEditing()"
      [isSaving]="$isSaving()"
      [surveyModel]="surveyModel"
      [transitions]="transitionsThatRequireValidation"
      (saveEvent)="onSave($event)"
      (editEvent)="onEdit()"
      (cancelEvent)="onCancel()" />
  }
</unity-page-container>
